import Actions from '@sigma-legacy-libs/essentials/lib/utils/Actions'

import { buttonModes, components, isObjectEmpty, labelModes, services, sizes } from '@/utils'

import button from '@/components/button'
import rulesActionsDialogGeneratorsButtonsButton from '@/components/rules/actions/generators/buttons/button'
import rulesActionsDialogGeneratorsFallbacksFallback from '@/components/rules/actions/generators/fallbacks/fallback'
import { baseClass, ruleTags } from '@/components/rules/utils'
import gTag from '@/components/tag'
import textOverflow from '@/components/text/overflow'
import simpleValue from '@/components/trees/routes/simpleValue'

function renderDialogContent(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    this.dialogData.map(value => {
      switch (this.dialogType) {
        case 'text': {
          return h(
            components.textarea,
            {
              props: {
                value,
                label: this.getTranslate('messageRules.labels.text'),
                labelMode: labelModes.hidden,
                details: false,
                dense: true,
                readonly: true,
                clearable: true
              }
            }
          )
        }
        case 'fallbacks': {
          return h(
            rulesActionsDialogGeneratorsFallbacksFallback,
            {
              props: {
                value,
                readonly: true
              }
            }
          )
        }

        case 'buttons': {
          return h(
            rulesActionsDialogGeneratorsButtonsButton,
            {
              props: {
                value,
                disabled: true
              }
            }
          )
        }
      }
    })
  )
}
function renderDialog(h) {
  return h(
    'g-dialog',
    {
      props: {
        value: this.showDialog,
        rounded: true,
        maxWidth: 500
      },
      on: {
        input: event => {
          if (event === false) {
            this.dialogData = []
            this.dialogType = undefined
          }
          this.showDialog = event
        }
      }
    },
    [
      h(
        'div',
        {
          class: 'pa-3'
        },
        [ renderDialogContent.call(this, h) ]
      ),

      h(
        'div',
        {
          class: 'fjcfe pa-2',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                mode: buttonModes.flat,
                label: this.getTranslate('misc.buttons.close')

              },
              on: {
                click: () => {
                  this.showDialog = false
                }
              }
            }
          )
        ]
      )
    ]
  )
}

function renderType(h, tag) {
  return h(
    textOverflow,
    {
      class: 'routes-conditions__condition-type',
      props: { value: this.getTranslate(`${baseClass}.tags.${tag}`) }
    }
  )
}
function renderValue(h, tag, value) {
  if (value) {
    if (Array.isArray(value) && value.length <= 0) {
      return
    }
    if (isObjectEmpty(value)) {
      return
    }

    switch (tag) {
      case ruleTags.type: {
        return h(
          gTag,
          {
            props: {
              label: this.getTranslate(`${services.sendings}.types.${value}`),
              size: sizes.tiny
            }
          }
        )
      }

      case ruleTags.moderation: {
        return h(
          gTag,
          {
            props: {
              label: value,
              size: sizes.tiny
            }
          }
        )
      }

      case ruleTags.sender: {
        let senderCount
        if (this.viewport.breakpoint.mdUp) {
          senderCount = 3
        } else if (this.viewport.breakpoint.sm) {
          senderCount = 2
        } else {
          senderCount = 1
        }

        return h(
          simpleValue,
          {
            props: {
              value,
              count: senderCount
            },
            on: {
              click: () => {
                this.dialogData = value
                this.dialogType = 'simple'
                this.showDialog = true
              }
            }
          }
        )
      }

      case ruleTags.text:
      case ruleTags.buttons:
      case ruleTags.fallbacks: {
        return h(
          'div',
          {
            class: 'routes-conditions__condition-value link',
            on: {
              click: () => {
                this.dialogData = value
                this.dialogType = tag
                this.showDialog = true
              }
            }
          },
          this.getTranslate('misc.buttons.show')
        )
      }
    }
  }
}
function renderAction(h, tag, value) {
  return h(
    'div',
    {
      class: 'routes-conditions__condition'
    },
    [
      renderType.call(this, h, tag),
      renderValue.call(this, h, tag, value)
    ]
  )
}

function renderActions(h) {
  const actions = this.value.reduce((result, { type, path, tag, value }) => {
    const tagMeta = Actions.tagsMeta[tag || type || path]
    if (tagMeta) {
      result.push(renderAction.call(this, h, tagMeta.tag, value))
    }

    return result
  }, [])

  return h(
    'div',
    {
      class: 'routes-conditions__items'
    },
    [ actions ]
  )
}

export default function(h) {
  if (Array.isArray(this.value) && this.value.length) {
    return h(
      components.card,
      {
        class: 'routes-conditions',
        props: {
          title: this.getTranslate(`${baseClass}.titles.actions`),
          flat: true
        }
      },
      [
        renderActions.call(this, h),
        renderDialog.call(this, h)
      ]
    )
  }
}
